const initialState = {
  auth: {
    access_token: null,
    notificationsToken: null,
  },
  dashboard: {
    dashboardHome: {},
    reservations: {
      upcoming: {
        reservations: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 10,
      },
      past: {
        reservations: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 10,
      },
      ongoing: {
        reservations: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 10,
      },
      pending: {
        reservations: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 10,
      },
    },
    userReviews: {
      approved: {
        reviews: [],
        pagination: {
          totalCount: 0,
          totalPages: 0,
          currentPage: 1,
          itemsPerPage: 10,
        },
      },
      pending: {
        reviews: [],
        pagination: {
          totalCount: 0,
          totalPages: 0,
          currentPage: 1,
          itemsPerPage: 10,
        },
      },
      rejected: {
        reviews: [],
        pagination: {
          totalCount: 0,
          totalPages: 0,
          currentPage: 1,
          itemsPerPage: 10,
        },
      },
      countsByType: {
        approved: 0,
        pending: 0,
        rejected: 0,
      },
    },
    userPayments: {
      payments: [],
      pagination: {
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 10,
      },
    },
    wishlist: {
      properties: [],
      pagination: {
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 10,
      },
    },
    userNotifications: {
      notifications: [],
      pagination: {
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 10,
      },
    },
    dashboardMessages: {
      chatsDetails: {
        chats: [],
        pagination: {},
        meta: {},
      },
      selectedChat: {
        bookingId: null,
        chatHeader: {},
        messages: null,
        bookingDetails: {},
      },
    },
  },
  profile: {
    userDetails: {},
  },
  user_preference: {
    language: "EN",
    currency: "USD",
    exchange_rate: 1,
  },
  loading: {
    isLoading: false,
  },
};
export default initialState;
